<template>
  <div>
  <el-tabs v-model="activeName">
    <div class="handle-box">
      <el-cascader :props="props" v-model="area_store" placeholder="选择或搜索门店" collapse-tags clearable
        filterable></el-cascader>
      <el-input v-model="query.mac_id" placeholder="机器编号"></el-input>
      <el-input v-model="query.pia_id" placeholder="商品ID"></el-input>
      <el-input v-model="query.moto_num" placeholder="柜门号"></el-input>
      <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="addDevice">添加</el-button>
    </div>
    <el-table :data="tableData" border class="table" ref="multipleTable" header-cell-class-name="table-header"
      :cell-style="centerStyle">
      <el-table-column prop="id" label="ID" width="55" align="center"></el-table-column>
      <el-table-column prop="name" label="设备名" width="200" show-overflow-tooltip
        header-align="center"></el-table-column>
      <el-table-column prop="code" label="编码" header-align="center" width="200">
        <template #default="scope">
          <el-button type="text" :style="'color:#409EFF'" @click="showDetail(scope.row.id)">
            {{ scope.row.code }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column prop="control" label="控制位" width="75"></el-table-column>
      <el-table-column prop="store_name" label="门店"></el-table-column>
      <el-table-column prop="sim_card" label="流量卡号" header-align="center"></el-table-column>
      <el-table-column prop="sim_end_time" label="流量卡到期时间" show-overflow-tooltip header-align="center"
        :formatter="dateFormatHMS"></el-table-column>
      <el-table-column prop="newType" label="类型" align="center" width="120">
        <template #default="scope">
          <span>{{ typeMap.get(scope.row.type) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="是否有效" width="100" align="center">
        <template #default="scope">
          <el-button type="text" :style="'color:' + [!scope.row.is_validate ? 'red' : '']"
            @click="setIsvalidate(scope.$index, scope.row.id, !scope.row.is_validate)">
            {{ scope.row.is_validate ? "有效" : "无效" }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="240" align="center">
        <template #default="scope">
          <el-button type="text" @click="setControl(scope.row)" v-if="deviceAllow">控制
          </el-button>
          <el-button type="text" @click="showProduct(scope.row)">商品
          </el-button>
          <el-button type="text" icon="el-icon-edit" @click="editDevice(scope.row)">编辑
          </el-button>
        </template>

      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination background layout="total, prev, pager, next" :current-page="query.page"
        :page-size="query.page_size" :total="pageTotal" @current-change="handlePageChange"></el-pagination>
    </div>
  </el-tabs>
  <!-- 编辑弹出框 -->
  <el-dialog v-model="editVisible" :title="[form.code ? '编辑' : '添加'] + '设备'" @close="editVisible = false" :width="550">
    <el-form ref="form" :model="form" :rules="rules" label-width="100px">
      <el-form-item prop="name" label="名称：">
        <el-input v-model="form.name" placeholder="请输入名称"></el-input>
      </el-form-item>
      <el-form-item prop="code" label="编码：">
        <el-input v-model="form.code" placeholder="请输入编码"></el-input>
      </el-form-item>
      <el-form-item label="控制位：">
        <el-input-number v-model="form.control" :controls="false"></el-input-number>
      </el-form-item>
      <el-form-item prop="sim_card" label="流量卡号：">
        <el-input v-model="form.sim_card" placeholder="请输入卡号"></el-input>
      </el-form-item>
      <el-form-item prop="sim_end_time" label="到期时间：">
        <el-date-picker v-model="form.sim_end_time" type="datetime" value-format="YYYY-MM-DD HH:mm:ss"
          format="YYYY-MM-DD HH:mm:ss" placeholder="选择日期时间">
        </el-date-picker>
      </el-form-item>
      <el-form-item prop="store_id" label="门店：" class="w350">
        <el-select v-model.number="form.store_id" clearable @clear="clearRoom">
          <el-option v-for="item in storeOptions" :key="item.value" :label="item.label" :value="Number(item.value)"
            @click="getRoomOption(item.value)"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="设备来源：" class="w250" prop="from">
        <el-select v-model="form.from" clearable>
          <el-option v-for="item in fromOptions" :key="item.value" :label="item.label"
            :value="Number(item.value)"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="设备类型：" class="w250">
        <el-select v-model="form.type" disabled clearable>
          <el-option v-for="item in typeOptions" :key="item.value" :label="item.label"
            :value="Number(item.value)"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="is_validate" label="是否有效：">
        <el-switch v-model="form.is_validate"></el-switch>
      </el-form-item>
      <div style="text-align: right; margin-top: 10px">
        <el-button @click="editVisible = false">取消</el-button>
        <el-button type="primary" @click="saveEdit">保存</el-button>
      </div>
    </el-form>
  </el-dialog>
  <el-dialog title="货柜商品" v-model="productVisible" width="80%">
    <PiaProductDialog ref="product"></PiaProductDialog>
  </el-dialog>
  <el-dialog width="20%" title="控制" v-model="controlVisible">
    <div class="box">
      <el-form ref="form" :model="controlData" label-width="80px">
        <el-form-item label="柜门号:" v-if="deviceContorl">
          <el-input v-model="controlData.value"></el-input>
        </el-form-item>
        <el-form-item v-else label="开关：">
          <el-switch v-model="switchValue" active-color="#13ce66" inactive-color="#ff4949">
          </el-switch>
        </el-form-item>
        <div style="text-align: right; margin-top: 10px">
          <el-button @click="controlVisible = false">取消</el-button>
          <el-button type="primary" @click="controlEdit">发送</el-button>
        </div>
      </el-form>
    </div>
  </el-dialog>
  <el-dialog title="设备详情" v-model="detailVisible" width="30%">
    <div class="rowstyle">
      <el-row :gutter="16">
        <el-col :span="6">
          <div class="grid-content bg-purple">设备名</div>
        </el-col>
        <el-col :span="10">
          <div class="grid-content bg-purple">{{ detailData.name }}</div>
        </el-col>
      </el-row>
      <el-row :gutter="16">
        <el-col :span="6">
          <div class="grid-content bg-purple">设备编码</div>
        </el-col>
        <el-col :span="10">
          <div class="grid-content bg-purple">{{ detailData.code }}</div>
        </el-col>
      </el-row>
      <el-row :gutter="16">
        <el-col :span="6">
          <div class="grid-content bg-purple">控制位</div>
        </el-col>
        <el-col :span="10">
          <div class="grid-content bg-purple">{{ detailData.control }}</div>
        </el-col>
      </el-row>
      <el-row :gutter="16">
        <el-col :span="6">
          <div class="grid-content bg-purple">门店</div>
        </el-col>
        <el-col :span="10">
          <div class="grid-content bg-purple">{{ detailData.store_name }}</div>
        </el-col>
      </el-row>
      <el-row :gutter="16">
        <el-col :span="6">
          <div class="grid-content bg-purple">流量卡号</div>
        </el-col>
        <el-col :span="10">
          <div class="grid-content bg-purple">{{ detailData.sim_card }}</div>
        </el-col>
      </el-row>
      <el-row :gutter="16">
        <el-col :span="6">
          <div class="grid-content bg-purple">流量卡到期时间</div>
        </el-col>
        <el-col :span="10">
          <div class="grid-content bg-purple">{{ ForMatHMS(detailData.sim_end_time) }}</div>
        </el-col>
      </el-row>
      <el-row :gutter="16">
        <el-col :span="6">
          <div class="grid-content bg-purple">设备类型</div>
        </el-col>
        <el-col :span="10">
          <div class="grid-content bg-purple">{{ typeMap.get(detailData.type) }}</div>
        </el-col>
      </el-row>
      <el-row :gutter="16">
        <el-col :span="6">
          <div class="grid-content bg-purple">设备来源</div>
        </el-col>
        <el-col :span="10">
          <div class="grid-content bg-purple">{{ fromMap.get(detailData.from) }}</div>
        </el-col>
      </el-row>
      <el-row :gutter="16">
        <el-col :span="6">
          <div class="grid-content bg-purple">是否有效</div>
        </el-col>
        <el-col :span="10">
          <div class="grid-content bg-purple">{{ detailData.is_validate ? '有效' : '无效' }}</div>
        </el-col>
      </el-row>
      <el-row :gutter="16">
        <el-col :span="6">
          <div class="grid-content bg-purple">添加时间</div>
        </el-col>
        <el-col :span="10">
          <div class="grid-content bg-purple">{{ ForMatHMS(detailData.c_at) }}</div>
        </el-col>
      </el-row>
    </div>
  </el-dialog>
</div>
</template>

<script>
import moment from "moment";
import {
  controlDevice,
  getDeviceFrom,
  getDeviceList,
  getDeviceType,
  saveTYDevice,
  setDeviceIsvalidate
} from "@/api/device"
import { getAreaOption, getStoreOption } from "@/api/store";
import { getRoomOption } from "@/api/room";
import PiaProductDialog from "@/views/PiaProductDialog.vue";
export default {
  name: "PiaDeviceTable",
  components: { PiaProductDialog },
  props: {
    deviceType: {
      type: String,
      required: true,
    },
    deviceValue: {
      type: Number,
      required: true,
    },
    deviceAllow: {
      type: Boolean,
      required: true,
    },
    deviceContorl: {
      type: Boolean,
      required: true,
    }
  },
  data() {
    return {
      activeName: 'local-lock',
      controlVisible: false,
      switchValue: false,
      query: {
        page: 1,
        page_size: 10,
        mac_id: "",
        moto_num: undefined,
        store_id: undefined,
        pia_id: undefined
      },
      rules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        code: [{ required: true, message: '请输入编码', trigger: 'blur' }],
        store_id: [{ required: true, message: '请选择门店', trigger: 'change' }],
        from: [{ required: true, message: '请选择设备来源', trigger: 'change' }],
        sim_end_time: [{ required: true, message: '请选择过期时间', trigger: 'change' }],
        sim_card: [{ required: true, min: 20, max: 20, message: '请输入正确的流量卡号', trigger: 'blur' }]
      },
      tableData: [],
      storeOptions: [],
      roomOptions: [],
      fromOptions: [],
      pageTotal: 0,
      form: {
        id: 0,
        name: '',
        code: '',
        control: 0,
        is_validate: true,
        room_id: 0,
        delay: 0,
        sim_end_time: null,
        sim_card: ''
      },
      actTitle: "新增", // 弹框标题
      editVisible: false, // 弹框开启状态

      // 商品
      productVisible: false,
      fromMap: new Map(),
      typeMap: new Map(),
      controlData: {
        value: 0,
        id: 0,
      },
      detailVisible: false,
      detailData: {},
      areaOptions: [],
      area_store: [],
      props: {}
    };
  },
  mounted() {
    this.getCompant()
  },
  methods: {
    init() {
      this.getData();
      this.getStoreOption();
      this.getDeviceFromOption();
      this.getDeviceTypeOption();
    },

    getCompant() {
      this.props = {
        // checkStrictly: true,
        lazy: true,
        lazyLoad: this.lazyLoad
      }
    },

    dateFormatHMS: function (row, column) {
      const date = row[column.property];
      if (date === undefined || date === 0) {
        return "";
      }
      return moment(parseInt(date + "000")).format("YYYY-MM-DD HH:mm:ss")
    },

    centerStyle() {
      return 'text-align:center'
    },

    ForMatHMS(date) {
      return moment(parseInt(date + "000")).format("YYYY-MM-DD HH:mm:ss")
    },

    dateFormat: function (row, column) {
      const date = row[column.property];
      if (date === undefined) {
        return "";
      }
      return moment(parseInt(date + "000")).format("YYYY-MM-DD")
    },
    lazyLoad(node, resolve) {
      const { level } = node;
      if (level === 0) {
        this.getAreaOptions()
        let nodes = []
        if (this.areaOptions !== []) {
          setTimeout(() => {
            nodes = this.areaOptions.map(item => ({
              value: item.value,
              label: item.label,
              leaf: level >= 1
            }));
            // 通过调用resolve将子节点数据返回，通知组件数据加载完成
            resolve(nodes);
          }, 100);
        }
      }
      if (level === 1) {
        let nodes = []
        this.getStoreOption(node.value)
        if (this.storeOptions !== []) {
          setTimeout(() => {
            nodes = this.storeOptions.map(item => ({
              value: item.value,
              label: item.label,
              leaf: level >= 1
            }));
            // 通过调用resolve将子节点数据返回，通知组件数据加载完成
            resolve(nodes);
          }, 100);
        }
      }

    },
    // 获取地址列表
    getAreaOptions() {
      getAreaOption().then(res => {
        this.areaOptions = res
      })
    },
    // 获取 easy-mock 的模拟数据
    getData() {
      this.query.area_id = this.area_store !== null ? this.area_store[0] : null
      this.query.store_id = (this.area_store !== null && this.area_store.length > 1) ? this.area_store[1] : null
      this.tableData = []
      this.query.type = this.deviceValue
      getDeviceList(this.query).then(res => {
        this.pageTotal = res.count
        this.tableData = res.data
      })
    },


    // 触发搜索按钮
    handleSearch() {
      this.getData()
    },

    // 分页导航
    handlePageChange(val) {
      this.query.page = val
      this.getData()
    },

    // 添加弹框
    addDevice() {
      this.form = {}
      this.form.id = 0
      this.form.store_id = 0
      this.form.room_id = 0
      this.form.type = this.deviceValue
      this.editVisible = true
    },

    saveEdit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.form.sim_end_time = moment(this.form.sim_end_time).unix()
        saveTYDevice(this.form).then(() => {
          this.$message.success('保存成功')
          this.editVisible = false
          this.getData()
        })
      })
    },

    // 编辑弹框
    editDevice(row) {
      this.actTitle = "编辑"
      this.form = JSON.parse(JSON.stringify(row))
      this.form.sim_end_time = new Date(row.sim_end_time * 1000)
      this.form.code = row.code
      this.form.name = row.name
      this.form.control = row.control || 0
      this.form.is_validate = row.is_validate
      this.form.room_id = row.room_id || 0
      this.form.store_id = row.store_id || 0
      this.form.from = row.from
      this.form.type = this.deviceValue || 0
      this.form.id = row.id
      this.editVisible = true
      this.getRoomOption(this.form.store_id)
    },


    //获取门店信息
    getStoreOption(id) {
      this.storeOptions = [{ value: 0, label: '平台' }]
      getStoreOption(id).then(res => {
        res.forEach(function (val) {
          this.storeOptions.push({ label: val.label, value: parseInt(val.value) })
        }, this)
      })
    },


    // 获取房间信息
    getRoomOption(id) {
      getRoomOption(id).then(res => {
        this.roomOptions = []
        let that = this
        res.forEach(function (item) {
          that.roomOptions.push(item)
        })
      })
    },

    getDeviceTypeOption() {
      getDeviceType().then(res => {
        let that = this
        res.forEach(function (item) {
          that.typeMap.set(item.value, item.label)
        })
        this.typeOptions = res
      })
    },

    getDeviceFromOption() {
      getDeviceFrom().then(res => {
        let that = this
        res.forEach(function (item) {
          that.fromMap.set(item.value, item.label)
        })
        this.fromOptions = res
      })
    },

    clearRoom() {
      this.query.room_id = null
      this.form.room_id = null
      this.roomOptions = []
      this.searchRooms = []
    },

    // 打开子组件
    showProduct(row) {
      this.productVisible = true
      setTimeout(() => {
        this.$refs["product"].showProducts(row.id)
      }, 100)
    },

    // 设置状态
    setIsvalidate(index, id, isvalidate) {
      setDeviceIsvalidate(id, isvalidate).then(res => {
        if (res === true) {
          this.$message.success('保存成功')
          this.tableData[index].is_validate = isvalidate
        }
      })
    },

    //设置控制
    setControl(row) {
      this.controlData.value = null
      this.controlVisible = true
      this.controlData.id = row.id
    },

    //   保存控制
    controlEdit() {
      this.controlVisible = false
      controlDevice(this.controlData).then(res => {
        if (res === true) {
          this.$message.success('发送成功')
          this.getData()
        }
      })
    },

    //设备详情
    showDetail(id) {
      this.tableData.forEach(item => {
        this.fromMap.set(item.value, item.label)
        if (item.id === id) {
          this.detailData = JSON.parse(JSON.stringify(item))
        }
      })
      this.detailVisible = true
    }
  }
};
</script>
<style scoped>
.handle-box {
  margin-bottom: 20px;
}

.mr10 {
  margin-right: 10px;
}

.el-input {
  width: 220px;
  margin-right: 10px;
}

.el-dialog__body .el-select,
.el-dialog__body .el-input {
  width: 80%;
}

.box {
  margin: 0 auto;
}

.box .el-input {
  width: 60%;
}

.rowstyle {
  width: 100%;
  margin: 0 auto;
  padding-left: 15%;
}

.el-row {
  margin-bottom: 10px;
}

.el-col {
  border-radius: 4px;

}

.row-bg {
  padding: 5px 0;
  background-color: #f9fafc;
}

.grid-content {
  border-radius: 4px;
  min-height: 24px;
  text-align: center;
  line-height: 24px;
}

.tip {
  font-size: 12px;
  color: red;
}

.w350 {
  width: 350px;
}

.w250 {
  width: 250px;
}
</style>
